(function () {
    'use strict';

    angular.module("imApp").factory("departmentMenuService", ['$ihttp', function ($ihttp) {
        let service = {
            getDepartmentMenu: function (parms) {
                return $ihttp.post({
                    method: 2227,
                    parameters: parms || {}
                });
            },
            deleteObj: function (menu) {
                return $ihttp.post({
                    method: 2230,
                    parameters: menu
                });
            }
        };

        return service;
    }]);
})();
